import { Account, AccountStatus, BaseAccount } from '../../../domain/account.domain';

export type AccountFilter = <T extends BaseAccount>(account: T) => boolean;

export class AccountsContainer<T extends BaseAccount = Account> {

  private static readonly PREDEFINED_FILTERS: Map<string, AccountFilter> =
    new Map<string, AccountFilter>([
      ['EXCLUDE_CLOSED', (account: BaseAccount): boolean => account.status !== AccountStatus.CLOSED]
    ]);

  constructor(private accounts: Array<T>) {
  }

  get(accountId?: string): T {
    if (accountId === '$favorite' || accountId === undefined) {
      return this.getFavorite();
    }
    return this.accounts.find((account: T): boolean => accountId === account.id);
  }

  find(filter: (account: T) => boolean): T {
    return this.accounts.find(filter);
  }

  getAccounts(filter?: string | ((account: T) => boolean) ): Array<T> {
    if (typeof filter === 'string') {
      return this.accounts.filter(this.getPredefinedFilter(filter));
    }
    if (typeof filter === 'function') {
      return this.accounts.filter(filter);
    }
    return this.accounts;
  }

  getFavorite(): T {
    let favorite = this.accounts.find((account: T): boolean => account.favorite);
    if (favorite === undefined && this.accounts.length > 0) {
      favorite = this.accounts[0];
    }
    return favorite;
  }

  getSubContainer(filter: string | ((account: T) => boolean)): AccountsContainer<T> {
    return new AccountsContainer(this.getAccounts(filter));
  }

  private getPredefinedFilter(filter: string): AccountFilter {
    return AccountsContainer.PREDEFINED_FILTERS.get(filter);
  }
}
